import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable, empty, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from '../../environments/environment';

import { ClientModel } from '../models/client.model';


import * as moment from 'moment';

@Injectable({
	providedIn: 'root'
})

export class BaseService {

	constructor() { }
	
	private static selectedClient: ClientModel;

	public httpOptions = {
		headers: new HttpHeaders({
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		})
	};

	public httpFormOptions = {
		headers: new HttpHeaders({
			'Content-Type':  'application/x-www-form-urlencoded'
		})
	};

	public httpBaseOptions = {
		headers: new HttpHeaders({
			'Accept': 'application/json',
			'Content-Type': 'application/json',
			'parktoria-app-token': this.getApplicationGuid(),
			'parktoria-client-token': this.getClientGuid()
		})
		// , observe: 'response' as 'response'
		, observe: 'body' as 'body'
		, reportProgress: true
		, withCredentials: true
	};

	public getHeaders(){
		let httpBaseOptions = {
			headers: new HttpHeaders({
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'parktoria-app-token': this.getApplicationGuid(),
				'parktoria-client-token': this.getClientGuid()
			})
			// , observe: 'response' as 'response'
			, observe: 'body' as 'body'
			, reportProgress: true
			, withCredentials: true
		};
		return httpBaseOptions;
	}
	
    public handleCreationError(error: Response) {
        return Observable.throw(error);
    }

    public handleDeletionError(error: Response) {
        return Observable.throw(error);
    }

    public handleRetrievalError(error: Response) {
        return Observable.throw(error);
    }

    public getUserClientsList() {
        var tokenData = localStorage.getItem('token');
        if (tokenData != null) {
            var parsed = JSON.parse(tokenData);
            var clientList = parsed.clientList;
            return clientList;
        }
    }

	// public getSelectedClient() {
	// 	if (BaseService.selectedClient == null) {
	// 		let storedClient = localStorage.getItem('clientKey');
	// 		if (storedClient != null) {
	// 			BaseService.selectedClient = JSON.parse(storedClient);
	// 			return BaseService.selectedClient;
	// 		} 
	// 	} else {
	// 		return BaseService.selectedClient;
	// 	}
	// 	return null;
	// }

	public setSelectedClient(client: ClientModel) {
		BaseService.selectedClient = client;
		localStorage.setItem('selectedClient', JSON.stringify(client));

		// if (BaseService.clientObserver != null)
		//     BaseService.clientObserver.next(BaseService.selectedClient);
	}

	public getUserGuid() {
		var tokenData = localStorage.getItem('token');
		if (tokenData != null) {
			//console.log('found token data');

			var parsed = JSON.parse(tokenData);
			return parsed.userGuid;
		}
	}

	public getAccessRole() {
		var tokenData = localStorage.getItem('token');
		if (tokenData != null) {
			var parsed = JSON.parse(tokenData);
			return parsed.accessRole;
		}
	} 

	public getOwnerGuid() {
		var tokenData = localStorage.getItem('token');
		if (tokenData != null) {
			var parsed = JSON.parse(tokenData);
			return parsed.owner.ownerKey;
		}
	}

	public getClientGuid() {
		var selectedClient = localStorage.getItem('clientKey');
		if (selectedClient != null) {
			return selectedClient;
		} else {
			return '';
		}
	}

	public getSessionGuid() {
		var tokenData = localStorage.getItem('token');
		if (tokenData != null) {

			var parsed = JSON.parse(tokenData);
			return parsed.applicationGuid;
		}
	}

	public getApplicationGuid() {
		return environment.appToken;
	}

	public getUploadedFileUri(docNum: number, documentKey: string, preview: boolean, download: boolean){
		return environment.commonApiUrl + 'document/' + docNum + '?key=' + documentKey + '&preview=' + preview + '&download=' + download;
	}

	public getSecuredUploadedFileUri(docNum: number, documentKey: string, preview: boolean, download: boolean){
		var ownerKey: string = this.getClientGuid();
		var sessionKey: string = this.getSessionGuid();
		return environment.commonApiUrl + 'document/' + docNum + '?key=' + documentKey + '&ownerKey=' + ownerKey + '&sessionKey=' + sessionKey + '&preview=' + preview + '&download=' + download;
	}

	public cleanseUrlParam(val: any) {
		if (val === undefined || val == null || val === 'undefined' || val === 'null') {
			return '';
		} else if(val instanceof Date) {
			return moment(val).format('YYYY-MM-DDTHH:mm:ss Z');
		} else {
			return val;
		}
	}
	
}
